export default __webpack_public_path__ + "static/media/rocket_anim_25.505b7f13.png";